<template>
	<div>
		<h3>This website is currently inactive.</h3>
		<p>No public website is available on this domain.</p>
	</div>
</template>

<style lang="scss" scoped>
.button {
	padding: 6px 15px;
	display: inline-block;
	float: none;
	text-decoration: none;
	color: #fff;
	background: #0c9;
	border-radius: 5px;
	margin-top: 5px;

	&:hover {
		background: #04e6ae;
		color: #fff;
	}
}
</style>
